/** LLM ensemble 24h call-volume + success-rate summary card. */
export const LLMSummaryCard = ({ llm }) => {
  return (
    <div className="bg-[#121212] border border-zinc-800 p-3" data-testid="admin-llm-card">
      <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mb-2">LLM ensemble · 24h</div>
      <div className="grid grid-cols-3 gap-1.5 text-center mb-2">
        <div className="border border-zinc-800 py-1">
          <div className="text-[8px] uppercase tracking-widest text-zinc-500 font-mono">/hour</div>
          <div className="text-sm font-heading font-bold text-[#22C55E]">{llm.calls_last_hour}</div>
        </div>
        <div className="border border-zinc-800 py-1">
          <div className="text-[8px] uppercase tracking-widest text-zinc-500 font-mono">/24h</div>
          <div className="text-sm font-heading font-bold">{llm.calls_last_24h}</div>
        </div>
        <div className="border border-zinc-800 py-1">
          <div className="text-[8px] uppercase tracking-widest text-zinc-500 font-mono">ok</div>
          <div className={`text-sm font-heading font-bold ${llm.success_rate_24h >= 90 ? "text-[#22C55E]" : "text-[#EF4444]"}`}>
            {llm.success_rate_24h}%
          </div>
        </div>
      </div>
      <div className="space-y-1">
        {Object.entries(llm.by_provider_24h || {}).map(([p, n]) => (
          <div key={p} className="flex items-center justify-between text-[10px]">
            <span className="text-zinc-300 capitalize">{p}</span>
            <span className="font-mono text-zinc-400">{n}</span>
          </div>
        ))}
        {Object.keys(llm.by_provider_24h || {}).length === 0 && (
          <div className="text-[10px] text-zinc-600 font-mono">no calls in window</div>
        )}
      </div>
    </div>
  );
};
